module.exports = "https://r.nearpod.com/assets/media/image/link-icon-3d2b4dd214d1b9b06ea077f15b426da2.svg";